import { AuthenticationType, SimpleField } from 'areas/administration/authentication/types';

const toOptions = (values: string[]) => values.map((value) => ({ label: value, value }));

const username: SimpleField = { name: 'username', label: 'Username' };
const password: SimpleField = { name: 'password', label: 'Password', kind: 'secret' };
const port: SimpleField = { name: 'port', label: 'Port' };
const community: SimpleField = { name: 'community', label: 'Community PW', kind: 'secret' };

export const simpleFieldsConfig: Partial<Record<AuthenticationType, SimpleField[]>> = {
	[AuthenticationType.Wmi]: [{ name: 'domain', label: 'Domain' }, username, password],
	[AuthenticationType.Generic]: [
		username,
		password,
		{ name: 'param1', label: 'Param1' },
		{ name: 'param2', label: 'Param2' },
		{ name: 'param3', label: 'Param3' },
		{ name: 'param4', label: 'Param4' },
		{ name: 'param5', label: 'Param5' },
	],
	[AuthenticationType.Jdbc]: [
		username,
		password,
		{ name: 'host', label: 'Host' },
		port,
		{ name: 'database', label: 'Database' },
		{ name: 'driver', label: 'Driver' },
		{ name: 'connectionString', label: 'Connection string' },
	],
	[AuthenticationType.Ssh]: [username, password, port, { name: 'privateKey', label: 'Private key', kind: 'secret' }],
	[AuthenticationType.SnmpV1]: [community],
	[AuthenticationType.SnmpV2c]: [community],
	[AuthenticationType.SnmpV3]: [
		{
			name: 'securityLevel',
			label: 'Security level',
			kind: 'select',
			options: [{ label: 'None', value: '' }, ...toOptions(['noAuthNoPriv', 'authNoPriv', 'authPriv'])],
		},
		{ name: 'securityName', label: 'Security name' },
		{
			name: 'authProtocol',
			label: 'Authentication protocol',
			kind: 'select',
			options: toOptions(['MD5', 'SHA', 'HMAC128SHA224', 'HMAC192SHA256', 'HMAC256SHA384', 'HMAC384SHA512']),
			defaultValue: 'MD5',
		},
		{ name: 'authPassphrase', label: 'Auth passphrase', kind: 'secret' },
		{
			name: 'privacyProtocol',
			label: 'Privacy protocol',
			kind: 'select',
			options: toOptions(['DES', 'AES128', 'AES192', 'AES256', '3DES']),
			defaultValue: 'DES',
		},
		{ name: 'privacyPassphrase', label: 'Privacy passphrase', kind: 'secret' },
		{ name: 'engineId', label: 'Engine id' },
		{ name: 'contextEngineId', label: 'Context engine id' },
		{ name: 'contextName', label: 'Context name' },
	],
	[AuthenticationType.Amazon]: [
		{ name: 'accessKeyId', label: 'Access key id' },
		{ name: 'secretAccessKey', label: 'Secret access key', kind: 'password' },
		{ name: 'awsRegion', label: 'AWS region' },
	],
	[AuthenticationType.Azure]: [
		{ name: 'subscriptionId', label: 'Subscription id' },
		{ name: 'tenant', label: 'Tenant' },
		{ name: 'client', label: 'Client' },
		{ name: 'key', label: 'Key', kind: 'secret', clearable: false },
	],
	[AuthenticationType.GoogleCloud]: [
		{ name: 'projectId', label: 'Project id' },
		{ name: 'privateKey', label: 'Private key', kind: 'secret', clearable: false, multiline: true },
		{ name: 'dataset', label: 'Dataset' },
	],
	[AuthenticationType.OAuth2]: [
		{ name: 'apiKey', label: 'API key' },
		{ name: 'apiSecret', label: 'API secret', kind: 'password' },
		{ name: 'authServer', label: 'Authentication server' },
		{ name: 'tokenServer', label: 'Token server' },
		{ name: 'scope', label: 'Scope' },
	],
};
